module.exports = __webpack_public_path__ + "img/6_campaign_master.754290aa.png";